import * as React from 'react';

export const Loader = ({showLoader = 'hide'}) => {
    return (
        <>
            <div id="loader" className={showLoader}>
                <div><img src="images/loader.gif" alt={'loader'}/></div>
            </div>
        </>
    );
}
